/*
 * Created Date: 16-01-2024, 10:21:18 am
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Mon Mar 11 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import { MdOutlineSchool } from 'react-icons/md'
import { ROUTER_WORKSPACE_CATEGORIES } from './const'

export const workspaceCategoriesNavigationConfig = [
	{
		id: 'category',
		title: 'Chuyên mục',
		type: 'item',
		icon: <MdOutlineSchool className="text-[1.4rem]" />,
		link: ROUTER_WORKSPACE_CATEGORIES.list
	}
]
